module.exports = __webpack_public_path__ + "static/laseroterapia-image-2-b051f398e0c9cd04563876acca3ed943.png";